import { createContext, useContext } from 'react';

export const SnackBarContext = createContext();

export function useSnackBarContext() {
  return useContext(SnackBarContext);
}

// module.exports = { SnackBarContext, useSnackBarContext };
